module.exports = __webpack_public_path__ + "img/USflag.44e17467.svg";